export class NotificationPolicyConfigWebhook {
    'url';
    'headers';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "headers",
            "baseName": "headers",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigWebhook.attributeTypeMap;
    }
    constructor() {
    }
}
